import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Tracks page views by POSTing /api/events/view whenever the route changes.
 * Excludes /admin* routes to avoid polluting analytics.
 */
export default function usePageView() {
    const location = useLocation();
    const lastPath = useRef(null);

    useEffect(() => {
        const path = location.pathname + (location.search || "");
        if (lastPath.current === path) return;
        lastPath.current = path;
        if (path.startsWith("/admin") || path.startsWith("/login")) return;
        if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) return;

        api.post("/events/view", {
            path,
            referrer: document.referrer || "",
        }).catch(() => {});
    }, [location.pathname, location.search]);
}
